import { create } from 'zustand';
import type { PlanError } from 'src/services/apis/planErrors';

/** The plan error the upgrade modal is showing, if any. Written from outside React by the axios interceptor. */
export const usePlanLimit = create<{ error: PlanError | null; show: (e: PlanError) => void; close: () => void }>(
  (set) => ({
    error: null,
    show: (error) => set({ error }),
    close: () => set({ error: null }),
  })
);

/**
 * Invite and role-change refusals come from better-auth, not axios, so the interceptor never sees
 * them. Free is the only plan with a member limit or without the admin role, so the numbers are exact.
 */
export function showAuthPlanError(error: unknown): boolean {
  const code = (error as { code?: string } | null)?.code;
  if (code === 'PLAN_LIMIT') {
    usePlanLimit.getState().show({ code: 'PLAN_LIMIT', resource: 'member', limit: 3, used: 3, plan: 'free' });
    return true;
  }
  if (code === 'PLAN_FEATURE') {
    usePlanLimit.getState().show({ code: 'PLAN_FEATURE', feature: 'adminRole', plan: 'free' });
    return true;
  }
  return false;
}
